import styled from 'styled-components';
import { font, breakpoint } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (${breakpoint.mdMin}) {
    margin-bottom: 0px;
  }

  @media (${breakpoint.lgMin}) {
    width: 40%;
    .search-button {
      min-width: 120px;
    }
  }
`;

export const SearchInput = styled.input.attrs({ type: 'search' })<{ theme: Theme }>`
  border: 0;
  background: transparent;

  padding: 16px 16px 15px 54px;
  outline: 1px solid ${getColor('neutralWhite')};
  border-bottom: 1px solid ${getColor('borderPrimary')};
  background: transparent url('/icons/svg/search.svg') no-repeat 8px center;

  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: left;
  color: ${getColor('neutralBlack')};

  &::placeholder {
    color: ${getColor('neutralBlack')};
  }
  &.small {
    padding: 12px 16px 12px 54px;
  }
`;
